export default (props, vars) =>
  `${vars?.['defaultbox145']?.['item']?.['index'] + 1}. ${
    vars?.['defaultbox145']?.['item']?.['title']
  }`;
